import './WizardSteps.scss';
import { ReactNode } from 'react';

export interface WizardStepsProps {
    children: ReactNode;
}

export const WizardSteps = ({ children }: WizardStepsProps) => <div className="wizard-steps">{children}</div>;
